import { useEffect, useContext } from "react"
import * as Yup from "yup"
import GenericAssetForm from "./common/GenericAssetForm"
import { useFormikContext } from "formik"

// Cash initial values
export const cashInitialValues = {
  storageLocation: "",
}

// Cash validation schema
export const cashValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required")
    .min(3, "Min length: 3 characters")
    .max(100, "Max length: 100 characters")
    .matches(
      /^(?! )[A-Za-z0-9\-_.&()]+( [A-Za-z0-9\-_.&()]+)*(?<! )$/,
      "Allowed: letters, numbers, -, _, &, ., (, ). No leading/trailing/blank spaces."
    ),
  purchaseDate: Yup.string().required("Purchase Date is required"),
  purchasePrice: Yup.number()
    .typeError("Must be a positive number")
    .required("Purchase price/amount is required")
    .positive("Must be a positive number > 0")
    .min(1, "Value must be 1 or greater"),
  storageLocation: Yup.string()
    .min(3, "Min length: 3 characters")
    .max(80, "Max length: 80 characters")
    .matches(
      /^[A-Za-z0-9\s\-&.'()#]+$/,
      "Allowed: letters, numbers, spaces, -, &, ., ', (, ), #. No other special characters."
    ),
})

/**
 * Cash Form - Field-only component for AddAssets.js
 * This renders only the cash-specific fields without form wrapper
 * Used in ADD mode within AddAssets.js's existing Formik wrapper
 */
const CashForm = ({ values, setFieldValue, errors, touched, defaultCurrency }) => {
  const { setFieldTouched } = useFormikContext() || {}
  
  // Handle default currency setting
  useEffect(() => {
    if ((!values.purchaseCurrency || values.purchaseCurrency === "") && defaultCurrency) {
      setFieldValue("purchaseCurrency", defaultCurrency)
    }
  }, [values.purchaseCurrency, defaultCurrency, setFieldValue])

  return (
    <GenericAssetForm
      subCategory="cash"
      values={values}
      setFieldValue={setFieldValue}
      setFieldTouched={setFieldTouched}
      errors={errors}
      touched={touched}
      defaultCurrency={defaultCurrency}
      readOnly={false}
    />
  )
}

export default CashForm
